import React, { useEffect, useState, useMemo } from "react";
import * as moment from "moment";
import { FORMAT, BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import UploadDummy from 'web/assets/images/UploadDummy.png'
import { useHistory } from "react-router-dom";
import TooltipMaterial from "@material-ui/core/Tooltip";
import { Tooltip } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik, Field } from "formik";
import information from "web/assets/images/notification-blue.png";
import Spinner from "web/components/Spinner";
import Button from "web/components/Button";
import Breadcrumb from 'web/components/Breadcrumb';
import UploadSpecification from "web/components/UploadSpecification";
import YesNoModal from "web/components/YesNoModal";
import RequestDateModal from "./RequestDateModal";
import TextInput from "web/components/form-elements/TextInput";
import TextArea from "web/components/form-elements/TextArea";
import NumberInput from "web/components/form-elements/NumberInput";
import MultiSelect from "web/components/form-elements/MultiSelect";
import DatePicker from "web/components/form-elements/DatePicker";
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import { Helmet } from "react-helmet";
import Layout from "web/components/Layout";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import RadioButton from "web/components/form-elements/RadioButton";
import { HeadingWrapper, SectionWrapper, FormWrapper, BlankSection, FormDiv, PostLoaduploadWrapper, UploadSpec, CheckBoxWrapper, PalletSpecWrapper } from "./postLoadStyled"
import { INITIAL_STATE, getPostingMethodPlaceHolder, getPickUpDeliverableArr, getRecurrencePost, getNotesArr, getSellingArr, getDropLiveState, getAppointmentArr, getBidArr, getPostMethodArr, breadcrumbMapArr } from '../constants';
import { getLocationDetails, getCommunityGroupsApi, postLoadSearchById, postNeedSearchById, uploadSpec, createNeedApi, needUpdate, postNeedEditViewV2ById } from "redux/actions/postLoad";
import AlertModal from "web/components/AlertModal";
import OkCancelAlertModal from "web/components/OkCancelAlertModal";
import { getPostInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/postModalUtils";
import PalletsSidebar from 'web/components/PalletsSidebar';
import styles from "./postLoad.module.scss";
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import { fetchLanguageContentNew } from 'redux/actions/language';

import LocationDetails from '../LocationDetails'
import PalletSpecDetails from "../PalletSpecDetails";
import styled from "styled-components";
import { requestOrderCountApi } from "redux/actions/notificationCount";

const PostLoad = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem("token");
  const isBroker = localStorage.getItem('brokerAccount')
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const urlObject = useSelector((state) => state.urlParameters.payload);

  // fetch the language locale content from redux or call the api and get the data
  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  useEffect(() => {
    if (languageContentNew?.Buy_Arrow_PostLoad_Page) setPageLanguageContents(languageContentNew.Buy_Arrow_PostLoad_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  // fetching the required constants for the component
  const postingMethodPlaceHolder = getPostingMethodPlaceHolder(pageLanguageContents)
  const pickUpDeliverableArr = getPickUpDeliverableArr(pageLanguageContents)
  const recurrencePost = getRecurrencePost(pageLanguageContents)
  const notesArr = getNotesArr(pageLanguageContents)
  const sellingArr = getSellingArr(pageLanguageContents)
  const dropLiveState = getDropLiveState(pageLanguageContents)
  const appointmentArr = getAppointmentArr(pageLanguageContents)
  const bidArr = getBidArr(pageLanguageContents)
  const postMethodArr = getPostMethodArr(pageLanguageContents)
  const [multiSelectVal, setMultiSelectVal] = useState([]);

  // component states
  let fileArr = [];
  const [communityGroups, setCommunityGroups] = useState([])
  const [palletSpecFilesData, setPalletSpecFilesData] = useState()

  const [pageLoading, setPageLoading] = useState(false)
  const [activeSearch, setActiveSearch] = useState();
  const [expanded, expandedState] = useState();
  const [editResponse, setEditResponse] = useState();

  const [ptPlusOrderRequestEditFlag, setptPlusOrderRequestEditFlag] = useState(false)
  const [orderRefNumberDisableState, setOrderRefNumberDisableState] = useState(true)

  useEffect(() => {
    setActiveSearch((urlObject && urlObject.activeSearch) || 'Dashboard')
    expandedState((urlObject && urlObject.expanded) || 'panel1')

    if (!localStorage.getItem("token")) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      if (urlObject && urlObject.ptplusAdminPost) {
        setptPlusOrderRequestEditFlag(true)
        editPostFunPtPlus(urlObject.pagedata);
      } else if (urlObject && urlObject.postType && urlObject.id) {
        setptPlusOrderRequestEditFlag(false)
        editPostFun(urlObject.id);
      } else {
        setOrderRefNumberDisableState(false)
        setptPlusOrderRequestEditFlag(false)
        setEditResponse();
      }
    }
  }, []);

  const [palletImagesArr, setPaletImagesArr] = useState();
  let uploadPalletImageArr = []

  const [uploadImageStage, setUploadImage] = useState();
  // If the user has not selected any image, check the spec file list to see if the default image is present. If it exists, add it.
  const [defaultPostImage, setDefaultPostImage] = useState();
  const [recurrenceFlag, setRecurrenceFlag] = useState(0);
  const [recurrenceObjState, setRecurrenceStateObj] = useState(INITIAL_STATE);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);

  const [okCancelModal, setOkCancelModal] = useState(false);
  const toggleOkCancelModal = () => setOkCancelModal(!okCancelModal);

  const [recurrenceTitle, setRecurrenceTitle] = useState("");
  const [loadSuccessState, setLoadSuccessState] = useState(false);

  const [requestDateModal, setRequestDateModal] = useState(false);
  const requestDateToggleModal = () => setRequestDateModal(!requestDateModal);

  const [yesNomodal, setYesNoModal] = useState(false);
  const yesNoToggleModal = () => setYesNoModal(!yesNomodal);

  const [tooltipBidAccept, setTooltipBidAccept] = useState(false);
  const [tooltipDropTrailer, setTooltipDropTrailer] = useState(false);

  useEffect(() => {
    fetchPreReqData()
    let obj = {
      type: "PostInventory",
      activePage: "PostInventory",
    }
    dispatch({ type: 'POST_INVENTORY_URL', payload: obj })
    window.scrollTo(0, 0);
  }, [])

  const fetchPreReqData = async () => {
    // api response data is stored in redux and used, dont delete
    let locationResponse = await dispatch(getLocationDetails(token))
    let communityGroupResponse = await dispatch(getCommunityGroupsApi(token, localStorage.getItem('authId')))
    if (communityGroupResponse?.success) {
      let commGroups = communityGroupResponse?.data?.commDetails?.map(data => ({ label: data.commGroupName, value: data.id }))
      setCommunityGroups(commGroups)
    } else {
      if (communityGroupResponse.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      }
    }
  }

  const editPostFun = async (id) => {
    let obj = {
      type: "PostLoad",
      activePage: "PostLoad",
      expanded: 'panel1'
    }
    dispatch({ type: 'POST_LOAD_URL', payload: obj })

    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      // let response = await dispatch(postNeedSearchById(id, token));
      let response = await dispatch(postNeedEditViewV2ById(id, token));
      if (response?.success) {
        setRecurrenceFlag(0);

        if (response?.data?.postImageFiles && response?.data?.postImageFiles?.length !== 0) {
          // uploadPalletImageArr.push(response?.data?.postImageFiles[0])
          uploadPalletImageArr = response?.data?.postImageFiles[0]
          setUploadImage(response?.data?.postImageFiles[0]?.fileName)
        }
        if (response?.data?.postPreferences.postingMethod === "GROUP") {
          let communityGroupResponse = await dispatch(getCommunityGroupsApi(token, localStorage.getItem('authId')))
          if (communityGroupResponse?.success) {
            let commGroups = communityGroupResponse?.data?.commDetails?.map(data => ({ label: data.commGroupName, value: data.id }))
            setCommunityGroups(commGroups)

            let userSelectedGroups = response?.data?.postPreferences?.groupIdsList
            let userSelectedGroupsValue
            if (userSelectedGroups && userSelectedGroups.length) {
              userSelectedGroupsValue = commGroups.filter(item => userSelectedGroups.includes(item.value));
            }
            if (userSelectedGroupsValue && userSelectedGroupsValue.length) setMultiSelectVal(userSelectedGroupsValue)
          }
        }
        setEditResponse(response?.data);
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.data?.message || response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.')
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  // this function will prefill values from ptplus order request page (pending request data)
  const editPostFunPtPlus = async (pagedata) => {
    let obj = {
      type: "PostLoad",
      activePage: "PostLoad",
      expanded: 'panel1'
    }
    dispatch({ type: 'POST_LOAD_URL', payload: obj })

    if (pagedata?.recurringOrderDetails) {
      setRecurrenceFlag(2);
    } else {
      setRecurrenceFlag('');
    }
    if (pagedata?.postImageFiles && pagedata?.postImageFiles?.length !== 0) {
      uploadPalletImageArr = pagedata?.postImageFiles[0]
      setUploadImage(pagedata?.postImageFiles[0]?.fileName)
    }

    setEditResponse(pagedata);
  };

  const handleSubmit = async (props, specFileUpdatedValue) => {
    if (props.values.isSizeAvailable && props.values.size === '') {
      setModalContent("Size is required.");
      setModalLink("");
      toggleModal();
      return
    }
    if (props.values.isMoistureAvailable && props.values.moisture === '') {
      setModalContent("Moisture is required.");
      setModalLink("");
      toggleModal();
      return
    } else if (props.values.isGradeAvailable && props.values.grade === '') {
      setModalContent("Grade is required.");
      setModalLink("");
      toggleModal();
      return
    }

    if (props.values?.length !== '' && props.values?.length < 1) {
      setModalContent("Length should be greater than 1.");
      setModalLink("");
      toggleModal();
      return
    }
    if (props.values?.width !== '' && props.values?.width < 1) {
      setModalContent("Width should be greater than 1.");
      setModalLink("");
      toggleModal();
      return
    }
    if (props.values?.height !== '' && props.values?.height < 1) {
      setModalContent("Height should be greater than 1.");
      setModalLink("");
      toggleModal();
      return
    }

    if (props.values.postingPlacePreference === "GROUP" && props.values.postingMethod.length === 0) {
      setModalContent('Select atleast one community group to post.');
      setModalLink("");
      toggleModal();
      return;
    } else {
      callSubmitApi(props, specFileUpdatedValue);
    }
  };

  const callSubmitApi = async (props, specFileUpdatedValue) => {
    let appointmentStartTime = props.values.postLoadDeliveryWindowBegin
    if (editResponse?.appointmentStartTime && props.values.postLoadDeliveryWindowBegin === '08:00:00') {
      appointmentStartTime = editResponse?.appointmentStartTime
    }
    let appointmentEndTime = props.values.postLoadDeliveryWindowEnd
    if (editResponse?.appointmentEndTime && props.values.postLoadDeliveryWindowEnd === '17:00:00') {
      appointmentEndTime = editResponse?.appointmentEndTime
    }

    const fromTimeValue = parseInt(appointmentStartTime?.replace(":", ""));
    const toTimeValue = parseInt(appointmentEndTime?.replace(":", ""));
    if (toTimeValue <= fromTimeValue) {
      setModalContent("Delivery window time is invalid.");
      setModalLink("");
      toggleModal();
      return
    }

    //condition
    let conditionValue
    if (props.values.conditionRadioValue === 'recycled') conditionValue = ['RECYCLED']
    else if (props.values.conditionRadioValue === 'newCondition') conditionValue = ['NEW']
    else if (props.values.conditionRadioValue === 'combo') conditionValue = ['COMBO']
    else if (props.values.conditionRadioValue === 'cores') conditionValue = ['CORES']

    let dateTimevalue = `${props.values.bidCloseTime} ${props.values.postLoadBidCloseTime}`

    let vehiclePref = []
    if (props.values.noteRadio0) vehiclePref.push("FLAT_BED")
    if (props.values.noteRadio1) vehiclePref.push("VAN")
    if (props.values.noteRadio2) vehiclePref.push("STRAIGHT")
    if (vehiclePref.length === 0 && props.values.pickUpDeliverable === "DELIVERABLE") {
      setModalContent("Equipment required for delivery is a mandatory field.");
      setModalLink("");
      toggleModal();
      return
    }

    if (props.values.costCheckBox && !props.values.desiredPrice) {
      setModalContent("Target price is a mandatory field.");
      setModalLink("");
      toggleModal();
      return
    }
    // object for post/order recurrence if chosen
    let recurrencePayloadObject
    if (recurrenceFlag === 1 || recurrenceFlag === 2) {
      let recStartDateTemp = props.values?.recurranceStartDate
      // in case of rec order, rec start date and request del date are in sync, so chosing the req del date
      if (recurrenceFlag === 2) recStartDateTemp = props.values?.requestDeliveryDate

      recurrencePayloadObject = {
        pattern: {
          type: props.values.type,
          interval: props.values.interval,
          dayOfWeek: props?.values?.dayOfWeek,
          daysOfWeek: props.values.daysOfWeek,
          dayOfMonth: props.values.dayOfMonth,
          index: props.values.index,
        },
        range: {
          start: moment(recStartDateTemp).format('YYYY-MM-DD'),
          endBy: moment(props.values.recurranceEndDate).format('YYYY-MM-DD'),
          endAfterOccurrences: null,
        },
      }
    }

    // future - not used now -creating a recurrence object for ptplus order request need
    let ptplusOrderRequestRecurrenceObj
    if (ptPlusOrderRequestEditFlag && editResponse?.recurringOrderDetails) {
      ptplusOrderRequestRecurrenceObj = {
        pattern: {},
        range: {
          start: moment(editResponse?.recurringOrderDetails?.startDate).format('YYYY-MM-DD'),
          endBy: moment(editResponse?.recurringOrderDetails?.endDate).format('YYYY-MM-DD'),
          endAfterOccurrences: null
        }
      }
      if (editResponse?.recurringOrderDetails?.recType === 'WEEKLY') {
        ptplusOrderRequestRecurrenceObj.pattern.interval = editResponse?.recurringOrderDetails?.pattern.weekly.recuringEvery
        ptplusOrderRequestRecurrenceObj.pattern.daysOfWeek = editResponse?.recurringOrderDetails?.pattern.weekly.weekdays
        ptplusOrderRequestRecurrenceObj.pattern.dayOfWeek = "MONDAY"
        ptplusOrderRequestRecurrenceObj.pattern.type = "WEEKLY"
        ptplusOrderRequestRecurrenceObj.pattern.dayOfMonth = null
        ptplusOrderRequestRecurrenceObj.pattern.index = null
      } else if (editResponse?.recurringOrderDetails?.recType === 'MONTHLY') {
        if (editResponse?.recurringOrderDetails?.pattern.monthly.monthlyType == 'DAY') {
          ptplusOrderRequestRecurrenceObj.pattern.dayOfMonth = editResponse?.recurringOrderDetails?.pattern.monthly.dayType.recuringDay
          ptplusOrderRequestRecurrenceObj.pattern.interval = editResponse?.recurringOrderDetails?.pattern.monthly.dayType.recuringEvery
          ptplusOrderRequestRecurrenceObj.pattern.type = "MONTHLY"
          ptplusOrderRequestRecurrenceObj.pattern.daysOfWeek = []
          ptplusOrderRequestRecurrenceObj.pattern.dayOfWeek = null
          ptplusOrderRequestRecurrenceObj.pattern.index = null
        } else if (editResponse?.recurringOrderDetails?.pattern.monthly.monthlyType == 'CUSTOM') {
          ptplusOrderRequestRecurrenceObj.pattern.index = editResponse?.recurringOrderDetails?.pattern.monthly.custom.weekOfMonth
          ptplusOrderRequestRecurrenceObj.pattern.dayOfWeek = editResponse?.recurringOrderDetails?.pattern.monthly.custom.reccuringWeek
          ptplusOrderRequestRecurrenceObj.pattern.dayOfMonth = editResponse?.recurringOrderDetails?.pattern.monthly.custom.recuringEvery
          ptplusOrderRequestRecurrenceObj.pattern.type = "RELATIVEMONTHLY"
          ptplusOrderRequestRecurrenceObj.pattern.interval = null
          ptplusOrderRequestRecurrenceObj.pattern.daysOfWeek = []
        }
      }
    }

    // future - not used now - while implementing ptplus order request need creation
    let poNumberValue
    if (ptPlusOrderRequestEditFlag) {
      poNumberValue = props.values?.poNumber
    } else if (props.values?.poNumber) {
      poNumberValue = props.values?.poNumber
    } else {
      poNumberValue = editResponse?.ptPlusDetails?.poNumber || null
    }

    // conditional pallet type field
    let palletTypeValue
    if (props.values.palletType && props.values.palletType !== '') palletTypeValue = props.values.palletType
    else palletTypeValue = 'CUSTOM'

    let targetPrice = props.values.desiredPrice
    if (props.values.desiredPrice.toString().charAt(0) === "$") {
      targetPrice = props.values.desiredPrice.replace('$', '')
    }

    // payload data for create need
    let data = {
      authId: localStorage.getItem('authId'),
      locationId: props.values.locationId ? props.values.locationId : localStorage.getItem('locationId'),
      shippingAddress: {
        locationName: props.values.shipperName,
        address1: props.values.line1,
        address2: props.values.line2,
        city: props.values.city,
        state: props.values.state,
        zipCode: props.values.zip,
      },
      postTitle: props.values.title,
      postImageFiles: (uploadPalletImageArr && uploadPalletImageArr.length !== 0) ? uploadPalletImageArr :
        defaultPostImage ? [defaultPostImage] :
          (uploadImageStage && editResponse?.postImageFiles) ? editResponse?.postImageFiles : null,
      palletDetails: {
        material: props.values.materialRadioValue?.toUpperCase(),
        condition: conditionValue,
        palletType: palletTypeValue?.toUpperCase(),
        moisture: props.values.moisture,
        size: props.values.size,
        grade: props.values.grade,
        length: props.values.length,
        width: props.values.width,
        height: props.values.height,
        heatTreared: props.values.heatTreated,
      },
      specificationFiles: specFileUpdatedValue ? specFileUpdatedValue :
        palletSpecFilesData ? palletSpecFilesData : null,
      shippingMode: props.values.pickUpDeliverable === 'DELIVERABLE' ? "DELIVERY" : 'PICKUP',
      vehiclePreferences: props.values.pickUpDeliverable === 'DELIVERABLE' ? vehiclePref : null,
      requestedDate: moment(props.values.requestDeliveryDate).format('YYYY-MM-DD'),//requestedDelDate / 1000,
      distanceWillingToTravel: props.values.pickUpDeliverable !== 'DELIVERABLE' ? props.values.pickupMiles : null,
      postRecurrence: recurrenceFlag === 1 ? recurrencePayloadObject : null,
      orderRecurrence: recurrenceFlag === 2 ? ptPlusOrderRequestEditFlag && editResponse?.recurringOrderDetails ? ptplusOrderRequestRecurrenceObj : recurrencePayloadObject : null,
      unLoadingReq: props.values.pickUpDeliverable === 'DELIVERABLE' ? (props.values.dropLive === 'LIVE' ? 'LIVE_UNLOAD' : 'DROP_TRAILER') : null,
      appointmentType: (props.values.pickUpDeliverable === 'DELIVERABLE') ? (props.values.appointment === 'DELIVERY' ? "DELIVERY_WINDOW" : 'REQUEST_DELIVERY_APPOINTMENT') : null,
      appointmentStartTime: (props.values.pickUpDeliverable === 'DELIVERABLE') ? props.values.appointment === 'APPOINTMENT' ? props.values.appt : appointmentStartTime : null,
      appointmentEndTime: (props.values.pickUpDeliverable === 'DELIVERABLE' && props.values.appointment === 'DELIVERY') ? appointmentEndTime : null,
      lotDetails: {
        totLots: props.values.lots,
        qtyPerLot: props.values.quantityPerLot,
        totalQty: props.values.totalQuantity,
        originalQty: editResponse?.lotDetails?.originalQty && props.values.quantityMaxValue === 540 ?
          props.values.materialRadioValue === "plastic" || props.values.materialRadioValue === "other" ? props.values.quantityMaxValue
            : editResponse?.lotDetails?.originalQty : props.values.quantityMaxValue,
        lotPostingOption: props.values?.lotPostingOption === 'SplitByLot' ? "MULTIPLE" : 'SINGLE'
      },
      targetPrice: targetPrice,
      displayCostToMarket: props.values.costCheckBox ? true : false,
      postPreferences: {
        acceptanceMethod: props.values.bidAcceptanceMethod === 'MANUALLY_ACCEPT_BID' ? "MANUAL" : 'AUTOMATIC',
        bidCloseTime: moment(dateTimevalue).format('YYYY-MM-DDTHH:mm'),//new Date(biddingCloseDateTime) / 1000,
        postingMethod: props.values.postingPlacePreference === 'MARKET' ? "MARKET" : "GROUP",
        groupIdsList: props.values.postingPlacePreference === 'GROUP' ? props.values.postingMethod?.map(data => data.value) : null
      },
      comments: props.values.description,

      ptPlusDetails: {
        orderRefNumber: props.values.referenceNumber ? props.values.referenceNumber : editResponse?.plusDetails?.orderRefNumber || null,
        poNumber: poNumberValue,
        flatFee: props.values.flatFee,
        comment: editResponse?.plusDetails?.comment || ''
      }
    }
    // conditionally adding if hardwood/softwood is selected
    if (conditionValue?.includes('NEW') && props.values?.hardOrSoftWood !== '') {
      data.palletDetails.newConditionType = (props.values?.hardOrSoftWood === 'New - Hardwood') ? 'HARDWOOD' : 'SOFTWOOD'
    }
    // additional payload if it is a broker account
    if (isBroker === 'brokerAc') {
      let brokerOfficeHourStartValue = props.values.brokerOperationStartTime
      let brokerOfficeHourEndValue = props.values.brokerOperationEndTime

      const fromTimeValue = parseInt(brokerOfficeHourStartValue?.replace(":", ""));
      const toTimeValue = parseInt(brokerOfficeHourEndValue?.replace(":", ""));
      if (toTimeValue <= fromTimeValue) {
        setModalContent("Location's operation time is invalid.")
        setModalLink("");
        toggleModal();
        return
      } else if (!props.values.brokerOperationDays || props.values.brokerOperationDays?.length === 0) {
        setModalContent("Please select location's operation days.")
        setModalLink("");
        toggleModal();
        return
      } else {
        data.shippingAddress.locationDaysOfOperations = props.values.brokerOperationDays
        data.shippingAddress.locationOfficeHourStart = props.values.brokerOperationStartTime
        data.shippingAddress.locationOfficeHourEnd = props.values.brokerOperationEndTime
      }
    }
    let response;
    if (editResponse && !editResponse?.PtPlusEditData) {
      data.id = editResponse?.id
      response = await dispatch(needUpdate(data, token))
    } else {
      response = await dispatch(createNeedApi(data, token))
    }
    if (response?.success) {
      setLoadSuccessState(true);
      setModalContent(response?.data?.msg)
      setModalLink("");
      toggleModal();
      //to reset pt-plus order count
      dispatch(requestOrderCountApi(token));
    } else {
      setLoadSuccessState(false);
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const requestedDate = (props) => {
    return (
      <>
        <div className={`${styles.field} col-md-4 mb-7 ${ptPlusOrderRequestEditFlag && editResponse?.recurringOrderDetails && 'disable-date-picker-style'}`}>
          <div className="my-2">
            {props?.values?.pickUpDeliverable === 'PICK_UP' ? <p>{pageLanguageContents?.Arrow_Delivery_Requirement[4]?.Pickup_Date}</p> :
              <p>{pageLanguageContents?.Arrow_Delivery_Requirement[3]?.Delivery_Date}</p>}
          </div>
          <DatePicker
            name="requestDeliveryDate"
            placeholderText=""
            editResponse={editResponse}
            selectedDate={props.values.requestDeliveryDate}
            disabled={ptPlusOrderRequestEditFlag && editResponse?.recurringOrderDetails}
            callBackFun={(date) => {
              setRecurrenceStateObj({
                requestDeliveryDate: date,
              });
            }}
          />
        </div>
      </>
    );
  }
  const liveFields = (props) => {
    return (
      <>
        <div className="col-12">
          <div className="my-2">
            <p>{pageLanguageContents?.Arrow_Delivery_Requirement[22]?.Delivery_Appnt}</p>
          </div>
          <div className={`${styles.fieldGroup} row`}>

            {appointmentArr &&
              appointmentArr.map((value, index) => (
                <div className={`${styles.field} col-md-4`} key={index}>
                  <Field
                    component={RadioButton}
                    name="appointment"
                    id={value.value}
                    defaultValue={appointmentArr[0].value}
                    onSelect={(e) => {
                      if (e.target.value === "APPOINTMENT") {
                        yesNoToggleModal();
                      }
                    }}
                    label={value.label}
                  />
                </div>
              ))}

          </div>

        </div>
        <div className="col-12">
          <div className={`${styles.fieldGroup} row mb-4`}>
            {props.values.appointment === 'DELIVERY' && (
              <>
                <div className="col-4 mb-7">
                  <p className="mt-0">From</p>
                  <TimePickerInput
                    name="postLoadDeliveryWindowBegin"
                    selectedValue={editResponse?.appointmentStartTime ? editResponse?.appointmentStartTime : props.values?.postLoadDeliveryWindowBegin}
                    editResponse={editResponse}
                    showErrorMessages={true}
                    type="createPost"
                  />
                </div>
                <div className="col-4 mb-7">
                  <p className="mt-0">To</p>
                  <TimePickerInput
                    name="postLoadDeliveryWindowEnd"
                    selectedValue={editResponse?.appointmentEndTime ? editResponse?.appointmentEndTime : props.values?.postLoadDeliveryWindowEnd}
                    editResponse={editResponse}
                    showErrorMessages={true}
                    type="createPost"
                  />
                </div>
              </>
            )}
            {props.values.appointment === 'APPOINTMENT' && (
              <div className="col-md-4 col-sm-12 mb-7 mt-2">
                <TimePickerInput
                  name="appt"
                  selectedValue={props.values?.appt}
                  prePopulateState={editResponse}
                  editResponse={editResponse}
                  showErrorMessages={true}
                  type="createPost"
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const bidCloseDateTime = (props) => {
    return (
      <>
        <div className="row mb-0">
          <div className="col-12 mb-7">
            <div className="my-2">
              <p>{pageLanguageContents?.Arrow_MyPreferences[4]?.Bid_Close}<span className={styles.star}>&#42;</span></p>
            </div>

            <div className="row mb-0">
              {/* For mobile */}
              <div className="col-7 mb-2 mobile-menu">
                <DatePicker
                  name="bidCloseTime"
                  editResponse={editResponse}
                  placeholderText="Bid close time"
                  type={"PostNeed"}
                  props={props}
                  selectedDate={props.values?.bidCloseTime}
                  callBackFun={(val) => { }}
                />
              </div>
              {/* For Web */}
              <div className="col-4 mb-2 web-view-menu">
                <DatePicker
                  name="bidCloseTime"
                  editResponse={editResponse}
                  placeholderText="Bid close time"
                  type={"PostNeed"}
                  props={props}
                  selectedDate={props.values?.bidCloseTime}
                  callBackFun={(val) => { }}
                />
              </div>
              <div className="col-4 mb-0">
                <TimePickerInput
                  name="postLoadBidCloseTime"
                  type="time"
                  prePopulateState={editResponse}
                  editResponse={editResponse}
                  showErrorMessages={true}
                  //selectedValue={new Date(props?.values?.postLoadBidCloseTime).toLocaleTimeString()}                  
                  selectedValue={props?.values?.postLoadBidCloseTime}
                />
              </div>
            </div>
            {recurrenceFlag !== 0 &&
              <p style={{ marginTop: '-7px', fontSize: '15px' }}>Delivery date will adjust accordingly to the start date of each new post.</p>
            }
          </div>
        </div>
      </>
    );
  };
  const uploadImageApi = async (props, specFileUpdatedValue) => {
    if (palletImagesArr) {
      setPageLoading(true)
      let formDataPalletImages = new FormData();
      for (let i = 0; i < palletImagesArr.length; i++) {
        formDataPalletImages.append("uploadSpecification", palletImagesArr[i]);
      }

      let responseforimages = await dispatch(uploadSpec(formDataPalletImages, token));
      if (responseforimages.status === "SUCCESS") {
        uploadPalletImageArr = responseforimages.payload
        handleSubmit(props, specFileUpdatedValue);
      }

      setPageLoading(false)
    } else {
      handleSubmit(props, specFileUpdatedValue);
    }
  };

  const postNeedClick = async props => {
    // palletSpecFilesData should be in [{orignalfilename, filename}] format
    // if it is already converted in that format we can proceed with the create api
    // but if it is in input file type format then call the s3 bucket upload api and get the response after that proceed with create api
    // if no data is present show error message
    if (palletSpecFilesData && palletSpecFilesData?.length > 0 && palletSpecFilesData[0].orignalFileName) {
      if (palletImagesArr) {
        uploadPalletImageArr = []
        uploadImageApi(props, palletSpecFilesData)
      } else {
        handleSubmit(props, palletSpecFilesData);
      }
    } else {
      if (props.values.materialRadioValue === "wood" && (props.values.conditionRadioValue === 'recycled' || props.values.conditionRadioValue === 'cores') && props.values.palletType === "stringer" && props.values.size === "48x40" && props.values.grade === '') {
        setModalContent("Grade is required.");
        setModalLink("");
        toggleModal();
        return
      } else {
        if ((!palletSpecFilesData || palletSpecFilesData?.length === 0)) {
          setModalContent("Please upload the specification file.");
          setModalLink("");
          toggleModal();
          return
        } else {
          setPageLoading(true)
          let formData = new FormData();
          palletSpecFilesData.map((data) => formData.append("uploadSpecification", data))
          let response = await dispatch(uploadSpec(formData, ''));
          if (response.status === "SUCCESS") {
            let updatedSpecFilesData = response.payload
            setPalletSpecFilesData(response.payload)
            if (palletImagesArr) {
              uploadPalletImageArr = []
              uploadImageApi(props, updatedSpecFilesData)
            } else {
              handleSubmit(props, updatedSpecFilesData);
            }
          } else {
            setPageLoading(false)
            setModalContent("Specification file upload failed, please try again.");
            setModalLink("");
            toggleModal();
            return
          }
        }
      }

    }
  }

  const generatePdfDocument = async (imagePath) => {
    const fileUrl = process.env.REACT_APP_API_URL + '/order/image/' + imagePath;
    window.open(fileUrl)
  }

  const productImage = () => {
    if (defaultPostImage?.fileName || uploadImageStage) {
      return (
        <div className="row">
          <TooltipMaterial
            placement="top"
            arrow
            title={defaultPostImage?.fileName || uploadImageStage}
            enterTouchDelay={0}
          >
            <UploadSpec
              className="upload col-12"
              onClick={() => {
                generatePdfDocument(defaultPostImage?.fileName || uploadImageStage)
              }}
            >
              <img
                src={UploadDummy}
                alt="upload Dummy"
              />
              <span style={{ fontSize: '13px', marginTop: '7px', cursor: 'pointer' }}>{defaultPostImage?.fileName || uploadImageStage}</span>
            </UploadSpec>
          </TooltipMaterial>
        </div>
      );
    }
  }

  const initialValues = useMemo(() => getPostInitialValues(editResponse, multiSelectVal), [editResponse, multiSelectVal]);
  const validationSchema = useMemo(() => VALIDATION_SCHEMA(pageLanguageContents), [pageLanguageContents]);

  const postForm = () => {
    return (
      <>
        {editResponse !== "" && (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={(values) => { }}
          >
            {(props) => {
              const { errors, setFieldValue } = props;
              return (
                <>
                  <Form>
                    <SectionWrapper className="pt-3">
                      <LocationDetails
                        formikProps={props}
                        pageLanguageContents={pageLanguageContents}
                        ptPlusOrderRequestEditFlag={ptPlusOrderRequestEditFlag}
                        urlObject={urlObject}
                        postedNeedEditValues={editResponse}
                        page={'createNeed'}
                        orderRefNumberDisableState={orderRefNumberDisableState}
                      />
                    </SectionWrapper>

                    <SectionWrapper className="pt-3">
                      <HeadingWrapper className="mb-3">
                        <h6 className={styles.headingName}>
                          {pageLanguageContents?.Arrow_PostDetails[0]?.PostTitle}
                        </h6>
                        <img
                          src={RightArrow}
                          alt="RightArrow"
                          className="right-arrow"
                        />
                      </HeadingWrapper>
                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div>
                            <p className="mt-0">
                              {pageLanguageContents?.Arrow_PostDetails[1]?.Title}
                              <span className={styles.star}>&#42;</span>
                            </p>
                          </div>
                          <div>
                            <TextInput
                              name="title"
                              placeholder={pageLanguageContents?.Arrow_PostDetails[2]?.Title_Placeholder}
                              showErrorMessages={true}
                            />
                          </div>
                        </div>

                        <PostLoaduploadWrapper className="col-md-6 col-sm-12">
                          <div className="mb-2">
                            <p className="mt-0 d-none d-md-block">
                              &nbsp;
                            </p>
                          </div>
                          <div className="stepUpload">
                            <UploadSpecification
                              acceptFiles="image/png,image/jpeg,image/gif"
                              name="uploadPalletInventoryImg"
                              props={props}
                              ProfileName=""
                              CompanyName=""
                              pageType=""
                              fileArr={fileArr}
                              imageLoadCallBack={(imageArr) => {
                                setUploadImage()
                                setDefaultPostImage()
                                setPaletImagesArr(imageArr);
                              }}
                              callBackFun={(imageArr) => {
                                setPaletImagesArr(imageArr);
                              }}
                            />
                            {(defaultPostImage || uploadImageStage) && productImage()}
                          </div>
                        </PostLoaduploadWrapper>
                      </div>

                      <PalletSpecWrapper>
                        <PalletSpecDetails
                          formikValues={props}
                          editResponse={editResponse}
                          setPalletSpecFilesData={data => setPalletSpecFilesData(data)}
                          defaultPostImageCallBack={imgName => {
                            if (!palletImagesArr) {
                              setUploadImage()
                              if (imgName) setDefaultPostImage({ orignalFileName: imgName, fileName: imgName })
                              else setDefaultPostImage()
                            }
                          }} />
                      </PalletSpecWrapper>

                      <div className="row">
                        {pickUpDeliverableArr &&
                          pickUpDeliverableArr.map((value, index) => (
                            <div
                              className={`col-md-4 ${styles.field}`}
                              key={index}
                            >
                              {index === 0 ? (
                                <div className="my-2">
                                  <p>{pageLanguageContents?.Arrow_Delivery_Requirement[0]?.Title}</p>
                                </div>
                              ) : (
                                <div className={`my-2 ${styles.blankSpace}`}>
                                  <p>&nbsp;</p>
                                </div>
                              )}
                              <Field
                                component={RadioButton}
                                name="pickUpDeliverable"
                                id={value.value}
                                defaultValue={pickUpDeliverableArr[0].value}
                                onSelect={(e) => { }}
                                label={value.label}
                              />
                            </div>
                          ))}
                      </div>

                      <div
                        className="row">
                        {requestedDate(props)}
                        {!ptPlusOrderRequestEditFlag &&
                          <>
                            {!editResponse?.isRecurring && !editResponse?.isPostRecurring && (<>
                              <div className="mb-0 col-12">
                                <p className="mb-0">Scheduling Options</p>
                              </div>
                              <>{recurrencePost &&
                                recurrencePost.map((value, index) => (
                                  <CheckBoxWrapper
                                    className={`${styles.field} col-md-12`}
                                    key={index}
                                  >
                                    <CheckboxInput
                                      name={"isPostRecurring" + index}
                                      label={value.label}
                                      handleSelect={(val, label, flag) => {
                                        if (label === recurrencePost[0].label) {
                                          setFieldValue('isPostRecurring1', false)
                                          setRecurrenceFlag(1);
                                          if (flag) requestDateToggleModal();
                                          else setRecurrenceFlag(0);

                                          setRecurrenceTitle('Setup Recurring Post')
                                        } else if (label === recurrencePost[1].label) {
                                          setFieldValue('isPostRecurring0', false)
                                          setRecurrenceFlag(2);
                                          if (flag) requestDateToggleModal();
                                          else setRecurrenceFlag(0);

                                          setRecurrenceTitle('Setup Recurring Order')
                                        } else {
                                          setRecurrenceFlag(0);
                                        }
                                        if (props.values.type === "RELATIVEMONTHLY") {
                                          setRecurrenceStateObj({
                                            type: "MONTHLY",
                                            requestDeliveryDate: props.values.requestDeliveryDate,
                                          });
                                        } else {
                                          if (label !== recurrencePost[0].label) {
                                            setRecurrenceStateObj({
                                              type: props.values.type,
                                              requestDeliveryDate: props.values.requestDeliveryDate,
                                            });

                                          } else {
                                            setRecurrenceStateObj(INITIAL_STATE)
                                          }
                                        }
                                      }}
                                    />

                                    {index === recurrenceFlag - 1 && (
                                      <>{<TooltipMaterial
                                        placement="bottom"
                                        enterTouchDelay={0}
                                        arrow
                                        title={
                                          <>
                                            {props.values.type === "DAILY" && (
                                              <>
                                                <p>
                                                  {pageLanguageContents?.Arrow_Delivery_Requirement[7]?.ToolTipRecType}{" "}
                                                  <span>{props.values.type}</span>
                                                </p>
                                                <p>
                                                  {pageLanguageContents?.Arrow_Delivery_Requirement[8]?.ToolTipDays}{" "}
                                                  <span>{props.values.interval}</span>
                                                </p>
                                              </>
                                            )}
                                            {props.values.type === "WEEKLY" && (
                                              <>
                                                <p>
                                                  {pageLanguageContents?.Arrow_Delivery_Requirement[9]?.ToolTipType}{" "}
                                                  <span>{props.values.type}</span>
                                                </p>
                                              </>
                                            )}
                                            {props.values.type === "MONTHLY" && props.values.monthlyRadio === "Day" && (
                                              <>
                                                <p>
                                                  {pageLanguageContents?.Arrow_Delivery_Requirement[8]?.ToolTipDays}
                                                  <span>{props.values.noDay}</span>
                                                </p>
                                                <p>

                                                  <span>
                                                    {props.values.interval}
                                                  </span>
                                                </p>
                                              </>
                                            )}
                                            {props.values.type === "RELATIVEMONTHLY" && props.values.monthlyRadio !== "Day" && (
                                              <>
                                                <p>
                                                  {pageLanguageContents?.Arrow_Delivery_Requirement[12]?.ToolTipDoM}{" "}
                                                  <span>{props.values.dayOfWeek}</span>
                                                </p>
                                                <p>
                                                  {pageLanguageContents?.Arrow_Delivery_Requirement[11]?.ToolTipWoM}
                                                  <span>{props.values.index}</span>
                                                </p>
                                                <p>
                                                  {pageLanguageContents?.Arrow_Delivery_Requirement[10]?.ToolTipEM}{" "}
                                                  <span>
                                                    {props.values.dayOfMonth}
                                                  </span>
                                                </p>
                                              </>
                                            )}
                                            {props.values.recurrenceRadio !== "endAfter" && (
                                              <p>
                                                {pageLanguageContents?.Arrow_Delivery_Requirement[14]?.ToolTipED}
                                                <span>
                                                  {moment(props.values.recurranceEndDate).format(FORMAT)}
                                                </span>
                                              </p>
                                            )}
                                          </>
                                        }
                                      >
                                        <img
                                          className={`${styles.recurrenceOnTime} i-icon`}
                                          src={information}
                                          alt="information"
                                        />
                                      </TooltipMaterial>}</>
                                    )}
                                  </CheckBoxWrapper>
                                ))}</>
                            </>)}
                          </>}
                      </div>

                      {/* if this is ptplus order request need and if it has recurring order following div is shown*/}
                      {ptPlusOrderRequestEditFlag && editResponse?.recurringOrderDetails &&
                        <div className="row">
                          <div className="mb-0 col-12">
                            <p className="mb-0">Scheduling Options</p>
                          </div>
                          <CheckBoxWrapper
                            className={`${styles.field} col-md-12`}
                          >
                            <CheckboxInput
                              name="isOrderRecurrencePtPlus"
                              disabled
                              label='Recurring Order: Find one supplier to commit to fulfilling your need(s) based on your weekly, or monthly requirements.'
                            />
                          </CheckBoxWrapper>
                          <div style={{ marginLeft: '43px' }}>
                            <p style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '0px' }}>Recurring Summary:</p>
                            <p style={{ fontSize: '14px', marginTop: '0px' }}>{editResponse?.recurringSummaryText}</p>
                          </div>
                        </div>
                      }

                      {props?.values?.pickUpDeliverable === 'PICK_UP' && (
                        <div className="row">
                          <div className="col-md-6 col-sm-6 mb-7">
                            <div>
                              <p className="mt-0">
                                {pageLanguageContents?.Arrow_Delivery_Requirement[27]?.Pickup_Distance}
                                <span className={styles.star}>&#42;</span>
                              </p>
                            </div>
                            <div>
                              <NumberInput
                                name="pickupMiles"
                                placeholder={pageLanguageContents?.Arrow_Delivery_Requirement[28]?.Pickup_Distance_Placeholder}
                                maxLength={4}
                                showErrorMessages={true}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {props?.values?.pickUpDeliverable === 'DELIVERABLE' && (
                        <>
                          <div className="row">
                            <div className="col-12">
                              <div className="mt-2 mb-0">
                                <p className="mb-0">
                                  {pageLanguageContents?.Arrow_Delivery_Requirement[15]?.Delivery_Equipment}
                                  <span className={styles.star}>&#42;</span>
                                </p>
                              </div>

                              <div className='row'>
                                <div className="checkbox-wrapper col-md-12">
                                  <div className="row">
                                    {notesArr.map((value, i) => (
                                      <div className="col-md-4">
                                        <CheckboxInput
                                          name={"noteRadio" + i}
                                          label={notesArr[i]}
                                          handleSelect={(val, label, flag) => { }}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* ptPlusOrderRequestEditFlag - means, prefill from prplus order request, in that case this div not needed */}
                          {dropLiveState.length !== 0 && !ptPlusOrderRequestEditFlag && (
                            <div className="row">
                              <div className="col-md-12 col-sm-3">
                                <div className="my-2">
                                  <p>{pageLanguageContents?.Arrow_Delivery_Requirement[19]?.Equipment_Unload}</p>
                                </div>
                                <div className={`${styles.fieldGroup} row`}>
                                  {dropLiveState.map((value, index) => (
                                    <div
                                      className={`${styles.field} col-md-4 test`}
                                      key={index}
                                    >
                                      <Field
                                        component={RadioButton}
                                        name="dropLive"
                                        id={value.value}
                                        defaultValue={dropLiveState[0].value}
                                        onSelect={(e) => { }}
                                        label={value.label}
                                        style={{ margin: "14px 0" }}
                                      />
                                      {/* {index === 1 &&
                                        <>
                                          <img
                                            id="TooltipDropTrailer"
                                            src={information}
                                            style={{
                                              paddingLeft: "5px",
                                              position: "relative",
                                              top: "-1px",
                                            }}
                                            alt="information"
                                          />
                                          <Tooltip
                                            placement="right"
                                            isOpen={tooltipDropTrailer}
                                            target="TooltipDropTrailer"
                                            toggle={() =>
                                              setTooltipDropTrailer(!tooltipDropTrailer)
                                            }
                                          >
                                            <InfoTitleText>Delivery will be scheduled as per the location operating hours.</InfoTitleText>
                                          </Tooltip>
                                        </>
                                      } */}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="row">
                            {liveFields(props)}
                          </div>
                        </>
                      )}
                    </SectionWrapper>
                    <SectionWrapper className="pt-3">
                      <HeadingWrapper className="mb-3">
                        <h6 className={styles.headingName}>
                          {pageLanguageContents?.Arrow_Price[0]?.Title}
                        </h6>
                        <img
                          src={RightArrow}
                          alt="RightArrow"
                          className="right-arrow"
                        />
                      </HeadingWrapper>
                      <div className="row pt-3">
                        <div className="col-md-4 col-sm-12 mb-7">
                          <div className="mb-2">
                            <p className="mt-0">
                              {pageLanguageContents?.Arrow_Price[1]?.Lot}<span className={styles.star}>&#42;</span>
                            </p>
                          </div>
                          <div>
                            <NumberInput
                              name="lots"
                              placeholder={pageLanguageContents?.Arrow_Price[1]?.Lot}
                              disabled={editResponse ? true : false}
                              maxLength={4}
                              decimalScale={0}
                              onChangeHandler={(value) => {
                                if (props.values.quantityPerLot > 0 && parseInt(value) > 0) {
                                  setFieldValue('totalQuantity', (props.values.quantityPerLot * parseInt(value)))
                                } else {
                                  setFieldValue('totalQuantity', '')
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className={`${styles.edit} col-md-4 col-sm-12 mb-7`}
                        >
                          <div className="mb-2">
                            <p className="mt-0">
                              <p className="mt-0">{pageLanguageContents?.Arrow_Price[2]?.Quantity}</p>{" "}
                            </p>
                          </div>
                          <div>
                            <NumberInput
                              name="quantityPerLot"
                              placeholder=""
                              maxLength={5}
                              decimalScale={0}
                              quantityLotsMaxValue={editResponse?.lotDetails?.originalQty && props.values.quantityMaxValue === 540 ?
                                props.values.materialRadioValue === "plastic" || props.values.materialRadioValue === "other" ? props.values.quantityMaxValue
                                  : editResponse?.lotDetails?.originalQty : props.values.quantityMaxValue}
                              onChangeHandler={(lotsValue) => {
                                if (props.values.lots > 0 && parseInt(lotsValue) > 0) {
                                  setFieldValue('totalQuantity', (props.values.lots * parseInt(lotsValue)))
                                } else {
                                  setFieldValue('totalQuantity', '')
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className={`${styles.Qty} col-md-4 col-sm-12 mb-7`}
                        >
                          <div className="mb-2">
                            <p className="mt-0">
                              <p className="mt-0">
                                {pageLanguageContents?.Arrow_Price[3]?.Total_Qunty}
                              </p>{" "}
                            </p>
                          </div>
                          <NumberInput
                            name="totalQuantity"
                            placeholder=""
                            disabled={true}
                            showErrorMessages={true}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 col-sm-12 mb-7">
                          <div className="mb-2">
                            <p className="mt-0">
                              {pageLanguageContents?.Arrow_Price[4]?.Target}
                              {(props.values.bidAcceptanceMethod === "AUTO_ACCEPT_LOW_BID" || props.values.costCheckBox) && <span className="star">*</span>}&nbsp;
                              <small>{pageLanguageContents?.Arrow_Price[5]?.PerPallet}</small>
                            </p>
                          </div>
                          <NumberInput
                            name="desiredPrice"
                            prefix={"$"}
                            placeholder="$ 0.00"
                            decimalScale={2}
                            maxLength={8}
                            decimalSeparator=","
                            fixedDecimalScale
                            thousandSeparator={true}
                          />
                        </div>
                        {/* {ptPlusOrderRequestEditFlag}---{props?.values?.poNumber} */}
                        {(ptPlusOrderRequestEditFlag || props?.values?.poNumber || editResponse?.plusDetails?.orderRefNumber) &&
                          <>
                            <div
                              className={`${styles.Qty} col-md-4 col-sm-12 mb-7`}
                            >
                              <div className="mb-2">
                                <p className="mt-0">
                                  <p className="mt-0">
                                    Flat Fee
                                  </p>{" "}
                                </p>
                              </div>
                              <NumberInput
                                name="flatFee"
                                prefix={"$"}
                                placeholder="$ 0.00"
                                decimalScale={2}
                                maxLength={8}
                                decimalSeparator=","
                                disabled={true}
                                fixedDecimalScale
                                thousandSeparator={true}
                              />
                            </div>

                            <div className={`${styles.Qty} col-md-4 col-sm-12 mb-7`}                            >
                              <div className="mb-2">
                                <p className="mt-0">
                                  <p className="mt-0">
                                    PO Number
                                  </p>{" "}
                                </p>
                              </div>
                              <TextInput
                                name="poNumber"
                                placeholder=""
                                showErrorMessages={true}
                              />
                            </div>
                          </>
                        }
                      </div>
                      {(ptPlusOrderRequestEditFlag || props?.values?.poNumber || editResponse?.plusDetails?.orderRefNumber) && <div className="row">
                        <div className={`${styles.Qty} col-md-12 col-sm-12 mb-7`}                            >
                          <div className="mb-2">
                            <p className="mt-0">
                              <p className="mt-0">
                                PT Internal
                              </p>{" "}
                            </p>
                          </div>
                          <div className={styles.ptPlusComment}>
                            <p>{editResponse?.plusDetails?.comment}</p>
                          </div>

                          {/* <TextArea
                              name="ptPlusComment"
                              maxLength="200"
                              disabled={true}
                              showErrorMessages={true}
                            /> */}
                        </div>
                      </div>}
                      {(props.values?.lots && props.values.lots > 1) &&
                        <div className="row">
                          <div className="col-12 mb-7">
                            <div className="my-2">
                              <p>Lots Posting Option</p>
                            </div>
                            <div className='row'>
                              {sellingArr &&
                                sellingArr.map((value, index) => (
                                  <div
                                    className={`${styles.field} col-md-6`}
                                    key={index}
                                  >
                                    <Field
                                      component={RadioButton}
                                      // name="lotPostingOption"
                                      name={(editResponse && index === 0) ? 'postingRadioDisable' : 'lotPostingOption'}
                                      disabled={editResponse ? true : false}
                                      id={value.value}
                                      defaultValue={sellingArr[0].value}
                                      onSelect={(e) => { }}
                                      label={value.label}
                                    />
                                    {index === 0 ? (
                                      <>
                                        <TooltipMaterial
                                          placement="right"
                                          enterTouchDelay={0}
                                          arrow
                                          // title={"Create individual posts on the marketplace for each lot to sell to multiple buyers."}
                                          title={
                                            <InfoTitleText style={{ padding: "2px" }}>
                                              Create individual posts on the marketplace for each lot to sell to multiple buyers.
                                            </InfoTitleText>
                                          }
                                        >
                                          <img
                                            style={{
                                              paddingLeft: "5px",
                                              position: "relative",
                                              top: "-1px",
                                            }}
                                            src={information}
                                            alt="information"
                                          />
                                        </TooltipMaterial>
                                      </>
                                    ) : (
                                      <>
                                        <TooltipMaterial
                                          placement="right"
                                          enterTouchDelay={0}
                                          arrow
                                          // title={"Create one post for all lots to sell all lots to one buyer."}
                                          title={
                                            <InfoTitleText style={{ padding: "2px" }}>
                                              Create one post for all lots to sell all lots to one buyer.
                                            </InfoTitleText>
                                          }
                                        >
                                          <img
                                            style={{
                                              paddingLeft: "5px",
                                              position: "relative",
                                              top: "-1px",
                                            }}
                                            src={information}
                                            alt="information"
                                          />
                                        </TooltipMaterial>
                                      </>
                                    )}
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      }

                      <div className="row">
                        <div className="col-12 align-items-end d-flex mb-7">
                          <div className={styles.field}>
                            <CheckboxInput
                              name="costCheckBox"
                              label={pageLanguageContents?.Arrow_Price[7]?.CheckBox}
                              handleSelect={() => { }}
                            />
                          </div>
                        </div>
                      </div>
                    </SectionWrapper>
                    <SectionWrapper className="pt-3">
                      <div>
                        <HeadingWrapper className="mb-3">
                          <h6 className={styles.headingName}>
                            {pageLanguageContents?.Arrow_MyPreferences[0]?.Title}
                          </h6>
                          <img
                            src={RightArrow}
                            alt="RightArrow"
                            className="right-arrow"
                          />
                        </HeadingWrapper>
                        <div className="row">
                          <div className="col-12">
                            <div className="my-2">
                              <p>{pageLanguageContents?.Arrow_MyPreferences[1]?.Bid}</p>
                            </div>
                            <div className='row'>
                              {/* <div className={`${styles.fieldGroup} col-md-6`}> */}
                              {bidArr &&
                                bidArr.map((value, index) => (
                                  <div
                                    className={`${styles.field} col-md-6 `}
                                    key={index}
                                  >
                                    <Field
                                      component={RadioButton}
                                      name="bidAcceptanceMethod"
                                      id={value.value}
                                      defaultValue={bidArr[0].value}
                                      onSelect={(e) => { }}
                                      label={
                                        <span>
                                          <span>{value.label}</span>
                                          {index === 0 && (
                                            <>
                                              <img
                                                id={`TooltipBidAccept`}
                                                src={information}
                                                style={{ paddingLeft: "5px", position: "relative", top: "-1px", }}
                                                alt="information"
                                              />
                                              <Tooltip
                                                placement="right"
                                                isOpen={tooltipBidAccept}
                                                target={`TooltipBidAccept`}
                                                toggle={() => setTooltipBidAccept(!tooltipBidAccept)}
                                              >
                                                <InfoTitleText>Automatically accept lowest bidder after bid close.</InfoTitleText>
                                              </Tooltip>
                                            </>
                                          )}
                                        </span>
                                      }
                                    />
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      {bidCloseDateTime(props)}
                      <div className="row">
                        <div className="col-12">
                          <div className={`${styles.fieldGroup} row `}>
                            {postMethodArr &&
                              postMethodArr.map((value, index) => (
                                <div
                                  className={`${styles.field} col-md-4`}
                                  key={index}
                                >
                                  <Field
                                    component={RadioButton}
                                    name='postingPlacePreference'
                                    id={value.value}
                                    defaultValue={postMethodArr[0].value}
                                    disabled={((value.value === 'GROUP' && communityGroups?.length < 1) || (value.value === 'GROUP' && props.values.locationType === 'sub')) ? true : false}
                                    label={value.label}
                                    onSelect={(e) => { }}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                      {/*   */}
                      {props.values?.postingPlacePreference === 'GROUP' && props.values.locationType === 'main' && communityGroups?.length > 0 && <div className="row">
                        <div className="col-12 mb-2">
                          <p>{pageLanguageContents?.Arrow_MyPreferences[7]?.Community}</p>
                          <div className={styles.fieldGroup}>
                            <div className="w-100">
                              {/* {editResponse?.postPreferences?.postingMethod} ---{props.values?.postingPlacePreference} */}
                              {editResponse ?
                                <>{(multiSelectVal?.length > 0 || (editResponse?.postPreferences?.postingMethod === "MARKET" || props.values?.postingPlacePreference === 'GROUP')) &&
                                  <MultiSelect
                                    name="postingMethod"
                                    data={communityGroups}
                                    multiSelectVal={multiSelectVal}
                                    // setMultiSelectVal={setMultiSelectVal}
                                    disabled={false}
                                    placeholder={postingMethodPlaceHolder}
                                    defaultValueArr={multiSelectVal}
                                  />}</>
                                : <MultiSelect
                                  name="postingMethod"
                                  data={communityGroups}
                                  multiSelectVal={multiSelectVal}
                                  // setMultiSelectVal={setMultiSelectVal}
                                  disabled={false}
                                  placeholder={postingMethodPlaceHolder}
                                  defaultValueArr={[]}
                                />}

                            </div>
                          </div>
                        </div>
                      </div>}
                      <div className="row">
                        <div className="col-12 mb-7">
                          <div className="my-2">
                            <p>{pageLanguageContents?.Arrow_MyPreferences[14]?.Note}</p>
                          </div>
                          <div className={styles.field}>
                            <TextArea
                              name="description"
                              maxLength="200"
                              showErrorMessages={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className={styles.footer}>
                        <Button
                          type="app-green-button"
                          handleClick={() => postNeedClick(props)}
                          disabled={Object.keys(errors).length !== 0}
                        >
                          {pageLanguageContents?.Arrow_MyPreferences[15]?.Button}
                        </Button>
                      </div>
                    </SectionWrapper>
                  </Form>

                  <RequestDateModal
                    isOpen={requestDateModal}
                    toggle={requestDateToggleModal}
                    title={recurrenceTitle}
                    recurrenceType="Need"
                    selectedType={props.values.pickUpDeliverable}
                    onClickHander={(recurrenceStateObj) => {
                      if (recurrenceStateObj.yesNoBtns === "no") {
                        setRecurrenceFlag(0)
                        setFieldValue('isPostRecurring0', false)
                        setFieldValue('isPostRecurring1', false)
                        setRecurrenceStateObj(INITIAL_STATE)
                      } else {
                        if (recurrenceFlag === 2 && recurrenceStateObj.start) setFieldValue("requestDeliveryDate", moment(recurrenceStateObj.start).format(FORMAT))
                        setRecurrenceStateObj(recurrenceStateObj);
                        let requestDeliveryDate = moment(recurrenceStateObj.requestDeliveryDate).format(FORMAT);
                        setRecurrenceStateObj({ requestDeliveryDate: requestDeliveryDate, });

                        setRecurrenceStateObj({ type: recurrenceStateObj.type, });
                        setFieldValue("type", recurrenceStateObj.type);
                        if (recurrenceStateObj.type === "DAILY") {
                          setFieldValue("interval", recurrenceStateObj.interval);
                          setFieldValue("dayOfWeek", null);
                          setFieldValue("dayOfMonth", null);
                          setFieldValue("index", null);
                        } else if (recurrenceStateObj.type === "WEEKLY") {
                          setFieldValue("interval", recurrenceStateObj.interval);
                          setFieldValue("dayOfWeek", null);
                          setFieldValue("daysOfWeek", recurrenceStateObj.daysOfWeek);
                          setFieldValue("dayOfMonth", null);
                          setFieldValue("index", null);
                        } else {
                          setFieldValue("start", recurrenceStateObj.start);
                          setFieldValue("monthlyRadio", recurrenceStateObj.theDayRadio);
                          setFieldValue("daysOfWeek", []);
                          setRecurrenceStateObj({ type: "MONTHLY" });
                          setRecurrenceStateObj({ theDayRadio: recurrenceStateObj.theDayRadio, });
                          if (recurrenceStateObj.theDayRadio === "Day") {
                            setFieldValue("index", null);
                            setFieldValue("dayOfWeek", null);
                            setFieldValue("noDay", recurrenceStateObj.noDay);
                            setFieldValue("interval", recurrenceStateObj.interval);
                            setFieldValue("dayOfMonth", recurrenceStateObj.noDay);
                          } else {
                            setFieldValue("type", "RELATIVEMONTHLY");
                            setFieldValue("interval", null);
                            setFieldValue("index", recurrenceStateObj.index);
                            setFieldValue("dayOfWeek", recurrenceStateObj.daysdropDown);
                            setFieldValue("dayOfMonth", recurrenceStateObj.dayOfMonth);
                          }
                        }
                        setFieldValue("recurrenceRadio", recurrenceStateObj.recurrenceRadio);
                        setFieldValue("recurranceStartDate", recurrenceStateObj.start)
                        setFieldValue("recurranceEndDate", recurrenceStateObj.endBy)
                      }
                    }}
                    recurrenceObjState={recurrenceObjState}
                    pageLanguageContents={pageLanguageContents}
                  />
                  <YesNoModal
                    isOpen={yesNomodal}
                    toggle={yesNoToggleModal}
                    title=""
                    onClickHander={(val) => {
                      if (val === "no") {
                        setFieldValue("appointment", "DELIVERY");
                      }
                    }}
                    content={pageLanguageContents?.Modals[0]?.Alert1}
                    link="/"
                  />
                </>
              );
            }}
          </Formik>
        )}
      </>
    );
  };
  return (
    <>
      <Helmet title="Post Your Pallet Needs to the Pallet Marketplace | PalletTrader" >
        <meta name="description"
          content="Need pallets? Efficiently manage your pallet procurement needs and post them to our marketplace. Connect with the largest online network of pallet sellers instantly." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/post-my-pallet-needs" />
      </Helmet>

      <Layout accountType="Buyer" pageType="postLoad" topBarViewMobile={"hide"}>
        {(loaderVisible || pageLoading) && <Spinner />}
        <div className={styles.postRequirement}>
          <Breadcrumb
            breadcrumbArr={breadcrumbMapArr}
            selected={pageLanguageContents?.Breadcrumb[1]?.PalletNeeds}
            title=""
          />
          <FormWrapper>
            <BlankSection>
              <PalletsSidebar activePage='PostLoad' activeSearch={activeSearch} expandedPallet={expanded}></PalletsSidebar>
            </BlankSection>

            <FormDiv>
              <div className={styles.headingTitle}>
                <h4>{pageLanguageContents?.Post_Load[0]?.Title}</h4>
                <p>{pageLanguageContents?.Post_Load[1]?.Description}</p>
              </div>
              {postForm()}
            </FormDiv>
          </FormWrapper>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title=''
            alertType="load"
            content={modalContent}
            link={modalLink}
            callBackAlert={() => {
              if (loadSuccessState) {
                let paginationObj = {
                  selectedPage: 1,
                }
                dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
                let obj = {
                  postType: "PostLoad",
                  type: "postedNeeds",
                  activePage: "PostLoad",
                  activeSearch: 'Dashboard',
                  expanded: 'panel1'
                }
                dispatch({ type: 'CREATED_NEEDS', payload: obj })
                history.push({
                  pathname: "/my-posted-pallet-needs",
                });
              }
            }}
          />
          <OkCancelAlertModal
            isOpen={okCancelModal}
            toggle={toggleOkCancelModal}
            alertType="postNeed"
            content={''}
            callBackAlert={() => {
              postNeedClick('')
            }}
          />
        </div>
      </Layout>
    </>
  );
};

export default PostLoad;

export const InfoTitleText = styled.div`
  font-size:14px !important;
  text-align:center !important;
  line-height: 18px !important;
`